<template>
    <div class="task-info-wrap" >
        <!-- 任务的表单 -->
        <div class="mod-title border">任务详情</div>
        <detail-form :name="false" :read="true" :sub='{}' :detailData="detail_data" :taskId="task_id"></detail-form>

        <!-- 关联任务  文档管理 -->
        <div class="mod-title border"></div>
        <div class="alone-func">
            <transition name="up">
                <div class="relation">
                    <div class="mod-title">关联任务：</div>
                    <relation :detailData="detail_data"></relation>
                </div>
            </transition>
            <transition name="up">
                <div class="remark">
                    <div class="mod-title">任务备注：</div>
                    <remarks :read="true" :detailData="detail_data" :taskId="task_id"></remarks>
                </div>
            </transition>
        </div>

    </div>
</template>


<script>

    import detailForm from "src/views/frontStage/task/detailTask/detail-form.vue"
    import remarks from "src/views/frontStage/task/detailTask/remark.vue"
    import relation from "src/components/read-relation.vue"

    import { mapState } from "vuex"

    export default {
        components: {
            remarks,
            detailForm,
            relation,
        },

        props:["taskId","prohibit"],

        data() {
            return {
                detail_data:{},  //任务详情数据
            }
        },
    
        computed: {
            ...mapState(["buInfo"]),
            task_id(){   //task id
                let str = this.$route.params.task_id;
                return this.taskId != undefined? this.taskId : this.$crypto.decrypt(str);
            },
            // read_judge(){   //冻结任务判断
            //     if(this.onlyread){
            //         return true;
            //     }
            //     let  data = this.detail_data;
            //     let status = data.category_status;
            //     let start = data.start_status;
            //     let dealing = data.dealing_status;
            //     let end = data.end_status;

            //     return this.task_id == 0?false:(status == 10 && start == 20) ||  (status == 20 && (dealing == 20 || dealing == 30)) || status == 30;
            // },
        },

        watch:{
            task_id(){
                this.getDetailData();
            }
        },

        created() {
            this.getDetailData();
            this.$func.getUserBu(true);   //获取登录用户BU
            this.$func.getCurrencyList(true);  //更新快币类型
            if(this.prohibit == true){
                return;
            }
            this.$func.getTaskTpl(true);  //更新任务类型
        },

        methods: {
            getDetailData(id = this.task_id){
                if(id != 0 ){
                    let url = `api/clerk/task/${id}`
                    this.$http.get(url).then(res => {
                        if(res.status == 200){
                            this.detail_data = res.res_data;
                        }
                    });
                }
            },
        },

    }
</script>

<style lang="less" scoped>
    // @import "~src/assets/less/var.less";
    // .task-info-wrap{
    //     color:#333;
    //     box-sizing:border-box;
    //     padding:30px;

    //     // 模块头部
    //     .mod-title{
    //         font-size:14px;
    //         padding-bottom:10px;
    //         font-weight:600;
    //         &.border{
    //             border-bottom: 1px dashed @detail_border;
    //         }
    //         .tip{
    //             color:#999;
    //             font-size:12px;
    //             font-weight:500;
    //         }
    //     }

    //     //虚线分割
    //     // .border{  
    //     //     position: absolute;
    //     //     width:calc(~"100% - 30px*2");
    //     //     height: 0;
    //     //     border-top: 1px dashed @detail_border;
    //     //     // left:0;
    //     // }

    //     // 独立部分
    //     .alone-func{
    //         margin-top :20px;
    //         // padding-bottom :25px;
    //         // width:calc(~"@{screen} - @{front_side_w} - @{front_padd}");
    //         overflow:hidden;
    //         .relation,.remark{
    //             float: left;
    //         }
    //         .relation{
    //             width:calc(~"100% - @{detail_right}");
    //         }
    //     }
    // }
</style>



// WEBPACK FOOTER //
// read-taskDetail.vue?118c492e